import { Component, Input, OnInit } from '@angular/core';
import { HelpText } from '../model/helpText.model';

@Component({
    selector: 'preview-help-text',
    templateUrl: './preview-help-text.component.html',
    styleUrl: './preview-help-text.component.scss'
})
export class PreviewHelpTextComponent implements OnInit {
    @Input() helpText?: HelpText;

    constructor() {}

    ngOnInit(): void {
        this.init();
    }

    init() {
       // console.log("PreviewHelpTextComponent being init'd with :");
       // console.log(this.helpText);

    }
}
